import {Injectable} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {catchError, concatMap, map} from 'rxjs/operators';
import {of} from 'rxjs';
import {VpcsService} from '../../../services/api/account/vpcs/vpcs.service';
import {
  loadOrganizationVPCList,
  loadOrganizationVPCListFailure,
  loadOrganizationVPCListSuccess
} from './organization-account.vpc-list.actions';
import {VPC} from '../../../services/api/account/vpcs/vpc.model';


@Injectable()
export class OrganizationAccountVPCListEffects {

  // noinspection JSUnusedGlobalSymbols
  loadOrganizationVPCList$ = createEffect(() => {
    return this.actions$
      .pipe(
        ofType(loadOrganizationVPCList),
        concatMap(() => {
            return this.service.getAll()
              .pipe(
                map((data: VPC[]) => loadOrganizationVPCListSuccess({data})),
                catchError((error: any) => of(loadOrganizationVPCListFailure({error})))
              );
          }
        )
      );
  });


  constructor(
    private readonly actions$: Actions,
    private readonly service: VpcsService
  ) {
  }

}
